var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.shown)?_c('div',[_vm._v(" Add app to home screen? "),_c('button',{on:{"click":_vm.installPWA}},[_vm._v("Install!")]),_c('button',{on:{"click":_vm.dismissPrompt}},[_vm._v("No, thanks")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }